import { render, staticRenderFns } from "./FootprintBungeEdible.vue?vue&type=template&id=708d2f2e&lang=pug"
import script from "./FootprintBungeEdible.vue?vue&type=script&lang=js"
export * from "./FootprintBungeEdible.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports